import jsrsasign from 'jsrsasign';

export const getDemoToken = (roles: string[], givenName: string, surname: string, userName: string): string => {
  const token = {
    aud: ['mms3_core', 'mms3_admin', 'mms3_import'],
    user_givenname: givenName,
    user_surname: surname,
    user_name: userName,
    user_id: 1337,
    scope: ['read'],
    exp: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 1000, // Valid for 1000 days
    authorities: roles,
    jti: '0',
    client_id: 'frontend',
  };

  return jsrsasign.KJUR.jws.JWS.sign(null, {alg: 'RS256'}, token, process.env.REACT_APP_DEMO_LOGIN_TOKEN_PK);
};
